import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import * as IBooks from '../../../../interfaces/merchants/resources/books';
import BooksPaymentItem from './BooksPaymentItem';

import css from './BooksPaymentMethods.module.scss';

interface Props extends React.HTMLProps<{}> {
  onChange: (e: React.ChangeEvent) => void;
  payments: IBooks.PaymentMethod[];
  selectedMethod?: IBooks.PaymentMethod['method'];
  subComponents: { [m in IBooks.PaymentMethod['method']]: React.ReactNode };
}

const BooksPaymentMethods = ({
  className,
  onChange,
  payments,
  selectedMethod,
  subComponents,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksPaymentMethods, className);
  return (
    <ul className={classes}>
      {payments.map((payment, index) => (
        <React.Fragment key={index}>
          <BooksPaymentItem
            payment={payment}
            checked={selectedMethod === payment.method}
            onChange={onChange}
          />
          {subComponents[payment.method]}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default injectIntl(BooksPaymentMethods);
